import { BaseService, axios } from '@/pigeonline/wrapper';
import { app } from '@/main.js';

export default class becnhmarkingService extends BaseService {
  async benchmarking(params = {}) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      let config = {};
      config['headers'] = this.getAuthHeader();
      config['params'] = params ? params : '';
      const response = await axios.get(`${URL}`, config);
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:benchmarking ' + e.message);
    }
  }

  async deleteBenchmark(id) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.delete(`${URL}/${id}`, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:deleteBenchmark ' + e.message);
    }
  }

  async update(id, data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.patch(`${URL}/${id}`, data, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:update ' + e.message);
    }
  }

  async recommendedGlobalQuestions(data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.post(`${URL}/recommended_global_questions`, data);
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:suggested ' + e.message);
    }
  }

  async request(data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.post(`${URL}`, data, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:request ' + e.message);
    }
  }

  async summaryResults(data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.post(`${URL}/summary_results`, data, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:summaryResults ' + e.message);
    }
  }

  async clientQuestionsDetails(data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.post(`${URL}/client_questions_analysis`, data, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:clientQuestionsDetails ' + e.message);
    }
  }

  async detailedResult(data) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      const response = await axios.post(`${URL}/detailed_results`, data, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:detailedResult ' + e.message);
    }
  }

  async segmentsDetails(params = {}) {
    try {
      const URL = app.config.globalProperties.$base_URL + '/analysis/benchmarking';
      let config = {};
      config['headers'] = this.getAuthHeader();
      config['params'] = params ? params : '';
      const response = await axios.get(`${URL}/segments_counts`, config);
      return response.data;
    } catch (e) {
      throw new Error('becnhmarkingService.js:segmentsDetails ' + e.message);
    }
  }
}
